<template>
  <transition name="pa-simple-fade">
    <div class="pa-podroom-controls" v-if="room.room_type === 'private'">
      <button
      class="button pa-additional-button"
      @click.prevent="handleClickButton"
      >{{buttonText}}</button>
    </div>
  </transition>
</template>

<script>
export default {
  props : {
    room : {
      default: null
    }
  },

  data(){
    return {
      buttonText : 'ーーーー'
    };
  },

  watch : {
    room : {
      handler(data){
        switch(data.role){
          case 'owner':
            this.buttonText = 'このポットを壊す';
          break;

          default:
            this.buttonText = 'このポットから離脱';
          break;
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleClickButton(){
      this.$emit('handleClick');
    }
  }
}
</script>

<style lang="scss">
.pa-podroom-controls{
  width:95%;
  margin:.5rem auto;
  
  .pa-additional-button{
    background-color:#C8AD8D;
    color:#867057;
    // color:#937C62;
    border:0;
    padding:.6rem .4rem;
    margin:0 .5rem 0 0;
    line-height:1;
    font-size:.7rem;
    height:auto;

    &:hover, &:active{
      color: #867057;
      background-color: #C8AD8D;
      border:0;
    }

    &:focus{
      box-shadow:none;
    }
  }
}
</style>